export default {
  title: 'Notifications Push',

  // Status messages
  status: 'Statut',
  permission: 'Permission',
  initializing: 'Initialisation...',
  notSupported: 'Les notifications push ne sont pas supportées dans ce navigateur',
  subscribing: 'Abonnement en cours...',
  unsubscribing: 'Désabonnement en cours...',
  sendingTest: 'Envoi d\'une notification de test...',
  sendingBroadcast: 'Envoi d\'une notification de diffusion...',

  // Success messages
  subscribeSuccess: 'Abonnement aux notifications push réussi !',
  unsubscribeSuccess: 'Désabonnement des notifications push réussi',
  testSent: 'Notification de test envoyée !',
  broadcastSent: 'Diffusion envoyée !',

  // Error messages
  subscriptionFailed: 'Échec de l\'abonnement',
  unsubscriptionFailed: 'Échec du désabonnement',
  testFailed: 'Échec de la notification de test',
  broadcastFailed: 'Échec de la diffusion',
  adminRequired: 'Accès administrateur requis pour les notifications de diffusion',

  // Button labels
  enableNotifications: 'Activer les Notifications Push',
  enableNotificationsTitle: 'Activer les Notifications Push',
  enableNotificationsDescription: 'Restez informé des mises à jour importantes et des activités dans Sloot.',
  subscribeToNotifications: 'S\'abonner aux Notifications Push',
  unsubscribeFromNotifications: 'Se Désabonner des Notifications Push',
  sendTestNotification: 'Envoyer une Notification de Test',
  sendBroadcastNotification: 'Envoyer une Notification de Diffusion (Admin)',

  // Modal benefits and content
  benefit1: 'Soyez notifié des nouvelles ressources et mises à jour',
  benefit2: 'Recevez les annonces importantes instantanément',
  benefit3: 'Restez connecté même quand l\'application est fermée',
  permissionNote: 'Vous pouvez modifier ce paramètre à tout moment dans les préférences de votre navigateur.',

  // Instructions
  instructionsTitle: 'Instructions :',
  instruction1: 'Cliquez sur "Activer les Notifications Push" pour demander la permission',
  instruction2: 'Une fois activées, vous pouvez envoyer des notifications de test',
  instruction3: 'Les notifications push fonctionnent même quand l\'application est fermée',

  // Test notification content
  testNotificationMessage: 'Ceci est une notification push de test pour vérifier que votre abonnement fonctionne.',

  // Broadcast notification content
  broadcastTitle: 'Diffusion de l\'Admin Sloot 📢',
  broadcastMessage: 'Ceci est un message de diffusion à tous les abonnés.',

  // Result messages
  resultSent: 'réussie(s)',
  resultTotal: 'total',
};
